<template>
    <div class="condition">
        <strong class="cxStrong">
            <a :href="titleUrl" target="_blank" @click="countAd(4238)"><em>{{$global.q}}</em>【热门车】</a>
        </strong>
        <div class="hotcarbox">
            <el-carousel :height="carouselHeight" :autoplay="false" :indicator-position="isShowIndicator" :arrow="isShowToggle">
                <el-carousel-item v-for="(page, count) in pageItems" :key="count">
                    <ul>
                        <li v-for="(item,index) in page.items" :key="index">
                            <i class="label" :class="[count === 0 && index < 3 ? 'label-orange' : 'label-blue']">{{(count * pageSize) + index + 1}}</i>
                            <a :href="`//price.pcauto.com.cn/sg${item.sgid}/`" target="_blank" class="pic" @click="countAd(4239)">
                                <img width="120" height="90" alt="" 
                                    :src="item.baiPicSrc || item.photoSrc || $indexConditionDefaultImaUrl">
                                <i class="tag tag-xss" v-if="item.sellStatus === 1"></i>
                                <i class="tag tag-jss" v-if="item.sellStatus === 2"></i>
                            </a>
                            <a :href="`//price.pcauto.com.cn/sg${item.sgid}/price.html`" target="_blank" class="tit blue" @click="countAd(4240)">{{item.sgname}}</a>
                            <a :href="`//price.pcauto.com.cn/sg${item.sgid}/price.html`" target="_blank" class="price red" v-if="item.minPrice === 0 && item.maxPrice === 0">暂无报价</a>
                            <a :href="`//price.pcauto.com.cn/sg${item.sgid}/price.html`" target="_blank" class="price red" v-else-if="item.minPrice === item.maxPrice" @click="countAd(4241)">{{item.minPrice}}万</a>
                            <a :href="`//price.pcauto.com.cn/sg${item.sgid}/price.html`" target="_blank" class="price red" v-else @click="countAd(4241)">{{item.minPrice}}-{{item.maxPrice}}万</a>
                        </li>
                    </ul>
                </el-carousel-item>
            </el-carousel>
            <div class="hotcarmore">
                <a :href="titleUrl" target="_blank" class="blue" @click="countAd(4224)" v-if="titleUrl">查看更多 &gt;&gt;</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Condition',
        props: {
            conditionData: {
                type:Object,
                default: () => ({})
            }
        },
        data() {
            return {
                totalHeight: 350,
                pageSize: 8,
                columns: 4,
            }
        },
        computed: {
            titleUrl() {
                let url 
                let reg = /qm/
                if(this.conditionData.urlWapParam){
                    if(reg.test(this.conditionData.urlWapParam)) {
                        url = `//price.pcauto.com.cn/price/newpower/q-${this.conditionData.urlWapParam}.html`
                    } else {
                        url = `//price.pcauto.com.cn/price/q-${this.conditionData.urlWapParam}.html`
                    }
                }
                return url
            },
            // 滑动卡片高度
            carouselHeight() {
                const rows = Math.ceil(this.pageSize / this.columns)
                const singleRowHeight = parseFloat(this.totalHeight / rows).toFixed(2)
                const curRow = Math.ceil(this.conditionData.items.length / this.columns)
                if (curRow < rows) {
                    return `${singleRowHeight * curRow}px`
                } else {
                    return `${this.totalHeight}px`
                }
            },
            // 是否显示指示器
            isShowIndicator() {
                if (this.pageItems.length > 1) {
                    return ''
                } else {
                    return 'none'
                }
            },
            // 是否显示切换
            isShowToggle() {
                if (this.pageItems.length > 1) {
                    return 'hover'
                } else {
                    return 'never'
                }
            },
            pageItems() {
                const pageSize = 8
                const totalItems = this.conditionData.items
                const total = totalItems.length
                const pageCount = Math.ceil(total / pageSize)
                let pageItems = Array(pageCount).fill()
                pageItems = pageItems.map((m, n) => {
                    let startIndex = n * pageSize
                    let endIndex = startIndex + pageSize
                    if (n === pageCount - 1) {
                        endIndex = total
                    }
                    return {
                        items: totalItems.slice(startIndex, endIndex)
                    }
                })
                return pageItems
            }
        },
    }
</script>

<style lang="scss" scoped>
.condition {
    margin-bottom: 25px;
    .cxStrong {
        font-weight: normal;
        font-size: 16px;
        line-height: 36px;
        display: inline-block;
        a {
            cursor: pointer;
            text-decoration: underline;
            color: #225599;            
        }
        em {
            color: #cc0000;
            text-decoration: underline;
            font-style: normal;
        }
    }
    .hotcarbox {
        width: 640px;
        &::v-deep .el-carousel__indicator button {
            background: #BFC3C8;
            width: 7px;
            height: 7px;
            border-radius: 50%;
        }
        &::v-deep .el-carousel__indicator.is-active button {
            width: 30px;
            border-radius: 20px;
            background: #0E60D5;
        }
        
        ul {
            margin-right: -50px;
            position: relative;
            zoom: 1; 
            display: flex;
            flex-wrap: wrap;
            li {
                margin-right: 46px;
                width: 120px;
                height: 164px;
                position: relative; 
                .pic {
                    display: block;
                    img {
                        border: 0;
                        vertical-align: middle;   
                    }
                    .tag {
                        position: absolute;
                        width: 15px;
                        height: 50px;
                        background: url($imageURL) no-repeat;
                        left: 120px;
                        top: 0px;
                    }
                    .tag-xss {
                        background-position: -51px -30px;                        
                    }
                    .tag-jss {
                        background-position: -35px -30px;
                    }
                } 
                .tit {
                    font-size: 14px;
                    font-weight: bold;
                    display: block;
                    text-align: center;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    height: 26px;
                    line-height: 26px;
                    margin-top: 2px;      
                    color: #225599;              
                }
                .price {
                    display: block;
                    text-align: center;  
                    color: #cc0000;                  
                }
                .label {
                    position: absolute;
                    width: 24px;
                    height: 13px;
                    line-height: 12px;
                    color: #fff;
                    font-style: normal;
                    text-align: center;
                    font-weight: bold;
                    background: url($imageURL) no-repeat;
                }
                .label-orange {
                    background-position: -35px -81px;
                }
                .label-blue {
                    background-position: -60px -81px;
                }              
            }           
        }
    }  
    .hotcarmore  {
        position: relative;
        .blue {
            color: #225599!important;
            text-decoration: underline;
        }        
    }
}
</style>